<template>
  <div class="detail-page" v-if="data">
    <van-list
      class="list-content"
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      @load="getComment"
    >
      <div class="van-list-container">
        <div class="detail-padding">
          <div class="top-container">
            <div class="top">
              <div class="title">{{ data.title }}</div>
              <div class="top-content">
                <div class="desc">
                  <span v-if="data.author_name"
                    >作者：{{ data.author_name }}</span
                  >
                  <span class="line" v-if="data.author_name"></span>
                  <span>查看次数：{{ data.num }}</span>
                  <span class="line"></span>
                  <span>关键词：</span>
                  <span class="keyword">{{ data.keyword1 }}</span>
                  <span class="keyword">{{ data.keyword2 }}</span>
                  <span class="keyword">{{ data.keyword3 }}</span>
                </div>
              </div>
            </div>
            <div class="info-content" @click="clickContent($event)">
              <div class="info" v-html="data.info"></div>
            </div>
            <div class="comment-content">
              <CommentContent
                :info="data"
                :data="commentData"
                @toUser="bindToUser"
                @showmore="bindShowmore"
                @delete="bindDeleteComment"
                @cancel="bindCancel"
              />
            </div>
            <div class="finish-content">
              <div class="not-more" v-if="finished && commentData.length"
                >没有更多评论了</div
              >
              <div class="not-comment" v-if="finished && !commentData.length"
                >暂时没有评论</div
              >
            </div>
          </div>
          <RecommendList :data="recommendData" />
        </div>
      </div>
    </van-list>
    <!-- 聊天框 -->
    <ChatContent
      ref="chatcontent"
      :articleInfo="data"
      :chatInfo="chatInfo"
      @resetUser="resetCommentInfo"
      @collect="bindCollectDynamic"
      @comment="bindComment"
      @like="bindlikeDynamic"
    />
    <GymSuspensionBtn :coefficientHeight="0.7">
      <div
        class="use-content"
        ref="copy"
        :data-clipboard-text="filterText"
        @click.stop="copyText"
      >
        <i class="iconfont icon-fuzhi"></i>
        <span class="text">引用</span>
      </div>
    </GymSuspensionBtn>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import Clipboard from 'clipboard'
import GymSuspensionBtn from '@/components/GymSuspensionBtn'
import CommentContent from '@/views/business-center/components/comment-content/index'
import ChatContent from '@/views/business-center/components/chat-content/index'
import RecommendList from '@/views/business-center/components/recommend-list/index'
export default {
  components: { CommentContent, ChatContent, RecommendList, GymSuspensionBtn },
  data() {
    return {
      clientHeight: '100%', //页面可视高度
      scrollTop: 0, //滚动高度
      isSubmitComment: false, // 是否正在提交评论
      clipboard: null,
      commentData: [],
      recommendData: [],
      loading: false,
      finished: false,
      data: null,
      isCollect: false,
      title: '详情',
      id: '',
      curPage: 1,
      imageList: [],
      chatInfo: {}, //当前正在聊天人的信息
      chatParentInfo: {}, //当前正在聊天人的父级信息
      parentIndex: '', // 当前点击的评论的父级index
      index: '' // 当前点击的评论处于父级第index + 1个
    }
  },
  watch: {
    $route(n, o) {
      if (n.fullPath !== o.fullPath) {
        //监听路由参数是否变化
        this.init() //methods中封装的加载数据函数
      }
    }
  },
  created() {
    this.getClientHeight()
    this.init()
  },
  mounted() {},
  computed: {
    filterText() {
      let res = this.data.info
      if (res) {
        res = res.replace(/<\/+.+?>/g, '\n')
        res = res.replace(/<\/?.+?>/g, '')
        res = res.replace(/&nbsp;/g, ' ')
      }
      return res
    }
  },
  methods: {
    getClientHeight() {
      this.clientHeight = document.documentElement.clientHeight + 'px'
    },
    init() {
      this.resetData()
      this.getParams()
      this.getDetail()
    },
    resetData() {
      this.isSubmitComment = false // 是否正在提交评论
      this.commentData = []
      this.recommendData = []
      this.loading = false
      this.finished = false
      this.data = null
      this.isCollect = false
      this.id = ''
      this.curPage = 1
      this.imageList = []
      this.chatInfo = {} //当前正在聊天人的信息
      this.chatParentInfo = {} //当前正在聊天人的父级信息
      this.parentIndex = '' // 当前点击的评论的父级index
      this.index = '' // 当前点击的评论处于父级第index + 1个
    },
    copyText() {
      console.log('复制')
      this.clipboard.on('success', () => {
        this.$toast.success('复制成功')
        this.setTypeInc()
      })
      this.clipboard.on('error', () => {
        this.$toast.fail('复制失败，请手动复制')
      })
    },
    //弹出回复或者删除弹框并点击取消时
    bindCancel() {
      this.resetCommentInfo()
    },
    //删除自己的评论
    bindDeleteComment(parentItem, item, parentIndex, index) {
      this.chatInfo = item
      this.chatParentInfo = parentItem
      this.parentIndex = parentIndex
      this.index = index
      let params = {
        id: this.chatInfo.id
      }
      this.resetCommentInfo()
      this.$http
        .postApp('member/StorageLogin/delComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.updateComment({ parentIndex, index, type: 'less' })
            this.$toast('删除成功')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
    },
    //更新评论 根据评论的内容是否有父评论决定加在哪里或者删除哪里
    updateComment({ parentIndex, index, type, data }) {
      if (type == 'add') {
        if (parentIndex !== '') {
          // 如果是在别人的评论下面评论
          this.commentData[parentIndex].comment_list.unshift(data)
        } else {
          //如果评论的是顶级的评论则直接在最上面新增评论
          this.commentData.unshift(data)
        }
      } else {
        if (parentIndex !== '' && index !== '') {
          //删除顶级评论下面的二级评论
          this.commentData[parentIndex].comment_list.splice(index, 1)
        } else {
          //删除顶级评论
          this.commentData.splice(parentIndex, 1)
        }
      }
    },
    //重置评论人信息
    resetCommentInfo() {
      this.index = ''
      this.parentIndex = ''
      this.chatInfo = {}
      this.chatParentInfo = {}
    },
    //评论某个用户
    bindComment(val) {
      if (this.isSubmitComment) {
        return
      }
      this.isSubmitComment = true
      let parentIndex = this.parentIndex
      let index = this.index
      let data_id = this.data.id
      let comment = val
      let t_uid = (this.chatInfo && this.chatInfo.uid) || 0
      let parent_id = (this.chatParentInfo && this.chatParentInfo.id) || ''
      let params = {
        data_id,
        t_uid,
        parent_id,
        comment
      }
      this.$http
        .postApp('member/StorageLogin/saveComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = res.data
            data.comment_list = []
            this.updateComment({
              parentIndex,
              index,
              type: 'add',
              data: data || {}
            })
            this.resetCommentInfo()
            this.$toast('评论成功')
          } else {
            this.$toast(res.msg)
          }
          this.isSubmitComment = false
        })
        .catch((err) => {
          console.log(err)
          this.isSubmitComment = false
          this.$toast('异常错误')
        })
    },
    bindShowmore(index) {
      this.commentData[index].showMore = true
    },
    //给请求的数据加上一些属性
    dealCommentData(data) {
      data.map((item) => {
        item.showMore = false
      })
      return data
    },
    getComment() {
      let params = {
        data_id: this.data.id,
        page: this.curPage
      }
      this.$http
        .postApp('member/StorageLogin/getComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.data && res.data.data.length) {
              console.log(this.dealCommentData(res.data.data))
              this.commentData = this.commentData.concat(
                this.dealCommentData(res.data.data)
              )
              this.curPage++
            } else {
              this.finished = true
              this.loadRecommend()
            }
          } else {
            this.$toast(res.msg)
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.$toast('异常错误')
        })
    },
    bindToUser(parentItem, item, parentIndex, index) {
      this.chatInfo = item
      this.chatParentInfo = parentItem
      this.parentIndex = parentIndex
      this.index = index
      this.$refs.chatcontent.bindShowInput()
    },
    //加载推荐
    loadRecommend() {
      let params = {
        type_id: this.data.type_id
      }
      this.$http
        .postApp('member/StorageLogin/getTop2', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.recommendData = (res.data && res.data.data) || []
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
    },
    getimgsrc(htmlstr) {
      var reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim
      var imgsrcArr = []
      let tem
      while ((tem = reg.exec(htmlstr))) {
        imgsrcArr.push(tem[2])
      }
      return imgsrcArr
    },
    //预览图片
    previewImage(imageList, url) {
      let index = imageList.indexOf(url)
      if (index < 0) {
        this.$toast('预览的图片不存在')
        return
      }
      ImagePreview({
        images: imageList,
        startPosition: index,
        loop: false
      })
    },
    clickContent(e) {
      let type = e.target.tagName.toLowerCase()
      let url = e.target.src || ''
      if (type === 'img' && this.imageList.length) {
        this.previewImage(this.imageList, url)
      }
    },
    getParams() {
      this.id = this.$route.query.id || ''
    },
    //更新收藏状态
    updateCollect() {
      this.isCollect = this.data.is_save === 0 ? true : false
    },
    getDetail() {
      let params = {
        tid: this.id
      }
      this.$http
        .postApp('member/StorageLogin/getDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data = res.data
            this.imageList = this.getimgsrc(res.data.info || '')
            this.updateCollect()
            this.setTypeInc()
            this.getComment()
            this.$nextTick(() => {
              this.clipboard = new Clipboard(this.$refs.copy, {
                text: () => {
                  return this.filterText
                }
              })
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    },
    //调用引用接口，引用后次数加1
    setTypeInc() {
      let params = {
        tid: this.id
      }
      this.$http
        .postApp('member/StorageLogin/setTypeInc', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.num = +this.data.num + 1
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
    },
    // 点赞这个文章
    bindlikeDynamic() {
      let params = {
        data_id: this.data.id,
        opt: this.data.is_useful ? 0 : 1
      }
      this.$http
        .postApp('member/StorageLogin/setUseful', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.is_useful = this.data.is_useful ? 0 : 1
            if (this.data.is_useful) {
              this.data.useful++
              this.$toast('点赞成功')
            } else {
              this.data.useful = --this.data.useful < 0 ? 0 : this.data.useful
              this.$toast('取消点赞')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    },
    //收藏
    bindCollectDynamic() {
      let params = {
        tid: this.data.id,
        type_0: this.data.type_id,
        type: this.data.is_save === 0 ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.is_save = this.data.is_save === 0 ? 1 : 0
            if (this.data.is_save === 0) {
              this.data.save_num = this.data.save_num + 1
              this.$toast('收藏成功')
            } else {
              this.data.save_num =
                --this.data.save_num < 0 ? 0 : this.data.save_num
              this.$toast('取消收藏')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    }
  }
}
</script>
<style lang="scss">
.detail-page {
  .info {
    .rich_pages {
      width: 100% !important;
      height: auto !important;
    }
    .wxw-img {
      width: 100% !important;
      height: auto !important;
    }
    section {
      margin: 0 !important;
      box-sizing: border-box;
    }
  }
}
</style>
<style lang="scss" scoped>
.detail-page {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f9f9f9;
}
.list-content {
  width: 100%;
  height: 100vh;
}
.detail-page .detail-padding {
  padding-bottom: 22vw;
}
.top-container {
  background-color: #fff;
  padding: 5.3vw;
  box-sizing: border-box;
}
.detail-page .top {
  width: 100%;
  background-color: #fff;
  padding-bottom: 3.5vw;
  border-bottom: 0.3vw solid #f7f7f7;
}
.detail-page .top .title {
  text-align: left;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  margin-bottom: 2.7vw;
  font-size: 4.8vw;
  color: #000;
}
.top .top-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.detail-page .top .desc {
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  text-align: left;
  color: rgba(0, 0, 0, 0.5);
}
.detail-page .top .desc .line {
  display: inline-block;
  height: 2.1vw;
  border-right: solid 0.3vw #979797;
  margin: 0vw 2.4vw;
}
.detail-page .top .desc .keyword {
  font-family: PingFangSC-Medium;
  font-size: 3.2vw;
  color: #2882e9;
  margin-right: 2.7vw;
}
.detail-page .info-content {
  margin-top: 3.5vw;
  border-bottom: 1px solid #f7f7f7;
}
.detail-page {
  .info {
    width: 100%;
    overflow-y: scroll;
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 3.7vw;
    line-height: 6.9vw;
    color: #4c4c4c;
  }
}
.finish-content {
  margin-top: 3vw;
}
.not-comment,
.not-more {
  color: rgba(0, 0, 0, 0.5);
  font-size: 3.2vw;
}
.comment-content {
  margin-top: 4.8vw;
}
.use-content {
  width: 16vw;
  height: 16vw;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .iconfont {
    color: #2882e9;
    margin-bottom: 0.8vw;
  }
  .text {
    font-size: 3.2vw;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #000;
    line-height: 4.5vw;
  }
}
.iframe {
  width: 100%;
  height: auto;
}
</style>
